module.exports = __webpack_public_path__ + "img/breaking-grey.2416de3.svg";